import { isBrowser } from './helper';
var globalObj = (isBrowser ? window : global);
globalObj.__dui_instance_counter__ = globalObj.__dui_instance_counter__ || {};
var counterMap = globalObj.__dui_instance_counter__;
export function createGlobalInstanceId(type) {
    counterMap[type] = counterMap[type] || 0;
    counterMap[type]++;
    return "dui" + type + "Id-" + counterMap[type];
}
